import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Button } from '../../components/Button';
import { useTranslation } from '../../hooks/useTranslation';

const GREEN = '#83D84D';

const FeatureItem = ({ icon, label }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      backgroundColor: '#F5F5F5',
      borderRadius: '8px',
      px: 2,
      py: 1.5,
      flexDirection: {
        xs: 'column',
        md: 'row'
      }
    }}
  >
    <Box sx={{ color: GREEN, display: 'flex' }}>{icon}</Box>
    <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#1F2937' }}>{label}</Typography>
  </Box>
);

const ModalApprovalSuccess = ({ open, onClose }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          border: `2px solid ${GREEN}`,
          backgroundColor: '#fff',
          backgroundImage: 'none',
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '20px',
            textAlign: 'center',
          }}
        >
          <VerifiedIcon sx={{ fontSize: 64, color: GREEN }} />

          <Box
            sx={{
              border: '1px solid #e0e0e0',
              borderRadius: '12px',
              p: 3,
              width: '100%',
            }}
          >
            <Typography sx={{ fontSize: '20px', fontWeight: 700, color: '#1F2937', mb: 1.5 }}>
              {t('approvalModal.primaryText')}
            </Typography>

            <Typography sx={{ fontSize: '14px', color: '#4B5563', mb: 0.5 }}>
              {t('approvalModal.secondText')} <strong>{t('approvalModal.thirdText')}</strong>
            </Typography>

            <Typography sx={{ fontSize: '14px', color: '#4B5563', mb: 2.5 }}>
              {t('approvalModal.fourthText')}{' '}
              <strong>{t('approvalModal.fifthText')}</strong>, {t('approvalModal.sixthText')}:
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 2.5 }}>
              <FeatureItem icon={<CalculateOutlinedIcon />} label="Simulações financeira" sx={{ border: '2px solid red'}}/>
              <FeatureItem icon={<PeopleAltOutlinedIcon />} label="Gerenciamento de clientes" />
              <FeatureItem icon={<LayersOutlinedIcon />} label="Consultas em massa" />
              <FeatureItem icon={<AddCircleOutlineIcon />} label="Outras novidades disponíveis para revendas" />
            </Box>

            <Typography sx={{ fontSize: '13px', color: '#6B7280' }}>
              {t('approvalModal.seventhText')}
            </Typography>
          </Box>

          <Button
            variant="contained"
            fullWidth={false}
            onClick={onClose}
            sx={{
              fontWeight: 700,
              fontSize: '13px',
              letterSpacing: '0.08em',
              px: 5,
              backgroundColor: GREEN,
              color: '#111827',
              '&:hover': { backgroundColor: '#6fc43a' },
            }}
          >
            {t('accessSystem').toUpperCase()}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
};

export default ModalApprovalSuccess;
